import { absoluteOffset } from '../utils/absoluteOffset'

interface DOMElements {
  container: HTMLElement
  navbar: HTMLElement
  button: HTMLButtonElement
}

export class TopScroll {
  private DOM: DOMElements

  constructor(container: HTMLElement) {
    this.DOM = {
      container,
      navbar: document.querySelector('.js-navbar') as HTMLElement,
      button: container.querySelector('.js-intro-top-scroll-btn') as HTMLButtonElement,
    }

    this.init()
  }

  private init() {
    this.bindEvents()
  }

  private bindEvents() {
    this.DOM.button.addEventListener('click', () => this.handleClick())
  }

  private handleClick() {
    const { top } = absoluteOffset(this.DOM.container)
    const height = this.DOM.container.getBoundingClientRect().height
    const navbarHeight = this.DOM.navbar.getBoundingClientRect().height

    window.scroll({
      top: top + height - navbarHeight,
      behavior: 'smooth',
    })
  }
}
